import { Typography } from "antd";
import { useState } from "react";
import AlertNotification from "./AlertNotification";

const SLInfo = ({
  line,
  desc,
  header,
  time,
  mainNews,
  id,
  callback,
  settings,
  isMobile,
}) => {
  const enableNotification = settings.notification;

  const [btnState, setBtnState] = useState(false);
  const toggle = () => setBtnState(!btnState);

  enableNotification === true &&
    mainNews === true &&
    id &&
    AlertNotification(id, header, desc, time, "SL");

  const NewDataHour = settings.newDataHour;
  const dateObj = new Date(time);
  const timeDiffMillis = Date.now() - dateObj.getTime();
  const timeDiffHours = timeDiffMillis / 1000 / 60 / 60;
  if (timeDiffHours > NewDataHour) {
    callback(false);
  } else {
    callback(true);
  }

  if (header === '')
    header = 'No headline'

  const divStyle = {
    borderBottom: "2px solid",
    borderColor: "white",
    padding: "10px",
    margin: "20px",
  };
  return (
    <>
      {isMobile === 'true' ?
        <div style={divStyle}>
          <Typography.Title level={5} onClick={toggle} className="tileHeader">
            {header}
          </Typography.Title>
          <p className="tileP"> Påverkade linjer: {line}</p>
          {btnState && <p className="tileP">{desc}</p>}
        </div>
        :
        <div style={divStyle}>
          <Typography.Title level={5} onClick={toggle} className="tileHeader">
            {header}
          </Typography.Title>
          <p className="tileP"> Påverkade linjer: {line}</p>
          <p className="tileP">{desc}</p>
        </div>
      }
    </>
  );
};
export default SLInfo;
